// extracted by mini-css-extract-plugin
export default {"cancel-button":"DeleteAccountModal_cancel-button__K9PiY","okay-button":"DeleteAccountModal_okay-button__FHGEG"};